import * as React from 'react';
import { StudyAdmissionCallToActionBlock } from '~/Blocks/StudyAdmissionCallToActionBlock/View/StudyAdmissionCallToActionBlock';
import { StudyPageAdmissionInfoBox } from '~/Features/StudyPage/Campus/Partials/StudyPageAdmissionInfoBox/StudyPageAdmissionInfoBox';
import { StudyHero } from '~/Features/StudyPage/Campus/Sections/StudyHero/StudyHero';
import type { CampusStudyPageHeroViewModel } from '~/Pages/CampusStudyPage/ViewModel/Hero/CampusStudyPageHeroViewModel.csharp';

export const CampusStudyPageHero: React.FC<CampusStudyPageHeroViewModel> = props => {
    const {
        title,
        summary,
        additionalInfo,
        imageViewModel,
        breadcrumbs,
        translations,
        admissionCallToAction,
        studyPageInfoBoxBlockViewModel,
    } = props;

    return (
        <StudyHero
            title={title}
            summary={summary}
            image={imageViewModel}
            info={additionalInfo}
            translations={translations}
            breadcrumbs={breadcrumbs}
        >
            <StudyPageAdmissionInfoBox
                choices={admissionCallToAction.choices}
                editorialInfo={studyPageInfoBoxBlockViewModel}
                translations={translations.admissionInfoBox}
                campusApplicationUrl={admissionCallToAction.campusApplicationUrl}
            />
            <StudyAdmissionCallToActionBlock {...admissionCallToAction} />
        </StudyHero>
    );
};
